// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1dPEF","footer":"ReportModalFilter_footer__EDcRR"};